import React from 'react';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        {/* CTA Section */}
        <motion.div 
          className="footer-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="cta-title">Stay Connected</h2>
          <p className="cta-description">
            Follow our journey as we curate the finest in rugged refinement. 
            Get inspired, get educated, get dressed.
          </p>
          
          {/* Pinterest Link - Main CTA */}
          <a 
            href="https://pin.it/2ivG62eu2" 
            target="_blank" 
            rel="noopener noreferrer"
            className="pinterest-cta"
          >
            <div className="pinterest-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>
              </svg>
            </div>
            <div className="pinterest-content">
              <span className="pinterest-label">Explore Our Vision</span>
              <span className="pinterest-handle">@slate_and_steel</span>
            </div>
            <div className="pinterest-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </div>
          </a>

          {/* Instagram Link */}
          <a 
            href="https://www.instagram.com/slate_and_steel/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="instagram-cta"
          >
            <div className="instagram-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </div>
            <div className="instagram-content">
              <span className="instagram-label">Follow Our Journey</span>
              <span className="instagram-handle">@slate_and_steel</span>
            </div>
            <div className="instagram-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </div>
          </a>

          <p className="social-note">
            Discover the predgy aesthetic — mood boards, outfit inspiration, 
            and the materials that define quality menswear.
          </p>
        </motion.div>

        {/* Footer Grid */}
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <img 
                src={process.env.PUBLIC_URL + '/logo/logo-cropped-transparent.png'} 
                alt="Slate & Steel" 
                className="footer-logo-image"
              />
            </div>
            <p className="brand-tagline">Rugged Refinement</p>
            <p className="brand-description">
              Merging prep and edge for the modern man. 
              Quality first, style always.
            </p>
          </div>

          <div className="footer-links">
            <h4>Explore</h4>
            <ul>
              <li><a href="#about">About</a></li>
              <li><a href="#philosophy">Philosophy</a></li>
              <li><a href="#catalog">Catalog</a></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>Materials</h4>
            <ul>
              <li>Full-Grain Leather</li>
              <li>Japanese Selvedge</li>
              <li>ELS Cotton</li>
              <li>Cashmere</li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>Connect</h4>
            <ul>
              <li>
                <a 
                  href="https://pin.it/2ivG62eu2" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Pinterest
                </a>
              </li>
              <li>
                <a 
                  href="https://www.instagram.com/slate_and_steel/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
              <li>Newsletter (Coming Soon)</li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-legal">
            <p>© {currentYear} Slate & Steel. All rights reserved.</p>
            <p className="legal-note">
              Predgy™ is a trademark of Slate & Steel.
            </p>
          </div>
          <div className="footer-aesthetic">
            <span className="aesthetic-line"></span>
            <span className="aesthetic-text">Prep × Edge</span>
            <span className="aesthetic-line"></span>
          </div>
        </div>
      </div>

      {/* Background Elements */}
      <div className="footer-bg-pattern"></div>
    </footer>
  );
};

export default Footer;

